import Keycloak from "keycloak-js";

const keycloakService = new Keycloak({
    url: process.env.REACT_APP_KEYCLOAK_URL ??'',
    realm: process.env.REACT_APP_KEYCLOAK_REALM ??'',
    clientId: process.env.REACT_APP_KEYCLOAK_CLIENTID ??''
});

keycloakService.onTokenExpired = () => {
  keycloakService.updateToken(300) // Tries to refresh the token if it expires within 300 seconds
    .then(() => console.log("Token successfully refreshed"))
    .catch(() => console.error("Failed to refresh token"));
};

const keycloakInterceptor = (config :any) => {
    const token = keycloakService.token;
    //console.log("Do interceptador: ", token);
    if (!token){
        console.log("Sem token.");
        return;
    }
    config.headers.Authorization = `Bearer ${token}`;
    return config;
};

export {keycloakInterceptor};
export {keycloakService};

export function getToken() {
    return keycloakService.token;
}
